<template>
  <v-container>
    <v-row v-if="resultadosPersonal.length == 0" justify="center">
      <v-col cols="4">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar justify-center font-weight-bold">Buscar personal</v-card-title>
          <v-card-text>
            <BaseInput
              class="ui-form-field"
              v-model="busquedaPersonal.nombre"
              label="Nombre"
              background-color="transparent"
            />
            <BaseInput
              class="ui-form-field"
              v-model="busquedaPersonal.segundoNombre"
              label="Segundo nombre"
              background-color="transparent"
            />
            <BaseInput
              class="ui-form-field"
              v-model="busquedaPersonal.apaterno"
              label="Apellido paterno"
              background-color="transparent"
            />
            <BaseInput
              class="ui-form-field"
              v-model="busquedaPersonal.amaterno"
              label="Apellido materno"
              background-color="transparent"
            />
            <BaseInput
              class="ui-form-field"
              v-model="busquedaPersonal.curp"
              label="CURP"
              background-color="transparent"
            />
            <BaseInput
              class="ui-form-field"
              v-model="busquedaPersonal.CUIP"
              label="CUIP"
              background-color="transparent"
            />
          </v-card-text>
          <v-card-actions class="justify-center pb-8 ui-module-actions">
            <v-container class="py-0">
              <v-row justify="center">
                <v-col cols="8" align="center">
                  <TextButton
                    class="ui-module-btn-solid"
                    @click="triggerSearchPersonal()"
                    :disabled="loading || emptyForm"
                    :loading="loading"
                  >
                    Realizar búsqueda
                  </TextButton>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else align="start">
      <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <TextButton class="ui-module-btn-outline" @click="RESET_BUSQUEDA_PERSONAL()"
              >Realizar nueva búsqueda</TextButton
            >
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="4">
            <BaseInput
              class="ui-form-field"
              label="Filtrar elementos"
              v-model="filtroPersonal"
              background-color="transparent"
            ></BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="4" xl="3" v-for="personal in filteredPersonal" :key="personal.id">
        <v-card class="ui-module-card ui-module-fade-in-up" color="secondary" elevation="8">
          <v-card-title>
            <v-container>
              <v-row>
                <v-col cols="12" align="center">
                  <v-avatar rounded color="primary" size="80" v-if="!hasFoto(personal) || personal.fotoError">
                    <v-icon x-large color="secondary">mdi-account</v-icon>
                  </v-avatar>
                  <v-img
                    v-else
                    :src="personal.foto"
                    max-height="80"
                    max-width="80"
                    @error="personal.fotoError = true"
                  />
                </v-col>

                <v-col cols="12" align="center">
                  <div class="text-h6 primary--text font-weight-bold">{{ personal.apaterno }}</div>
                  <div class="text-subtitle-1 primary--text">
                    {{ personal.amaterno + ' ' + personal.nombre + ' ' + personal.segundoNombre }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div class="text-caption primary--text">Evaluación C3 vigente hasta</div>
                  <div v-if="personal.vigenciaEvaluacionC3" class="text-subtitle-1 primary--text">
                    <v-row align="center" no-gutters>
                      <v-col class="pa-0" cols="7">
                        {{ formatFechaDirecta(personal.vigenciaEvaluacionC3) }}
                      </v-col>
                      <v-col class="pa-0" cols="5" align="right">
                        <Semaforo
                          :meses="getMesesDesdeVigenciaDirecta(personal.vigenciaEvaluacionC3)"
                          tipoRegla="profesionalizacion"
                          nombreVigencia="Evaluación C3"
                          :fechaVigencia="parseFechaDirecta(personal.vigenciaEvaluacionC3)"
                        />
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else class="text-subtitle-1 primary--text">Información no registrada</div>
                </v-col>
                <v-col cols="12">
                  <div class="text-caption primary--text">Competencias básicas</div>
                  <div v-if="personal.vigenciaCompetenciasBasicas" class="text-subtitle-1 primary--text">
                    <v-row align="center" no-gutters>
                      <v-col class="pa-0" cols="7">
                        {{ formatDateAjustada(personal.vigenciaCompetenciasBasicas) }}
                      </v-col>
                      <v-col class="pa-0" cols="5" align="right">
                        <Semaforo
                          :meses="getMesesDesdeVigencia(personal.vigenciaCompetenciasBasicas)"
                          tipoRegla="profesionalizacion"
                          nombreVigencia="Competencias básicas"
                          :fechaVigencia="getFechaVigenciaAjustada(personal.vigenciaCompetenciasBasicas)"
                        />
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else class="text-subtitle-1 primary--text" align="left">Información no registrada</div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="secondary darken-1 ui-module-actions">
            <v-container>
              <v-row>
                <v-col cols="12" align="right">
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text mx-2 ui-module-icon-action"
                        elevation="8"
                        :to="{
                          name: 'profesionalizacion.evaluacion_desempenio_academico',
                          params: { id: personal.idPersonal },
                        }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-school</v-icon></v-btn
                      >
                    </template>
                    <span>Realizar evaluación de desempeño académico</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text mx-2 ui-module-icon-action"
                        elevation="8"
                        :to="{
                          name: 'profesionalizacion.expedientePersonalSection',
                          params: { id: personal.idPersonal },
                        }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-file-account</v-icon></v-btn
                      >
                    </template>
                    <span>Ver expediente del personal</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import BaseInput from '@/components/base/BaseInput.vue'
import IconRoundedButton from '@/components/base/IconRoundedButton.vue'
import TextButton from '@/components/base/TextButton.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Semaforo from '@/components/SemaforoComponent.vue'

export default {
  components: {
    BaseInput,
    TextButton,
    IconRoundedButton,
    Semaforo,
  },
  data() {
    return {
      loading: false,
      filtroPersonal: '',
      selectedPersonal: null,
    }
  },
  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('personal', {
      resultadosPersonal: 'getPersonal',
      busquedaPersonal: 'getBusquedaPersonal',
    }),

    filteredPersonal: function () {
      return this.resultadosPersonal.filter((personal) => {
        return (
          this.getFullName(personal).toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.CUIP.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.rfc.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.curp.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0
        )
      })
    },

    emptyForm() {
      if (
        this.busquedaPersonal.nombre === '' &&
        this.busquedaPersonal.segundoNombre === '' &&
        this.busquedaPersonal.apaterno === '' &&
        this.busquedaPersonal.amaterno === '' &&
        this.busquedaPersonal.curp === '' &&
        this.busquedaPersonal.CUIP === ''
      ) {
        return true
      } else return false
    },
  },
  methods: {
    ...mapActions('personal', ['searchPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('personal', ['RESET_BUSQUEDA_PERSONAL']),

    async triggerSearchPersonal() {
      this.loading = true

      await this.searchPersonal(this.busquedaPersonal)
      if (this.resultadosPersonal.length == 0) {
        this.SET_SNACKBAR_MESSAGE('Búsqueda sin resultados.')
      }

      this.loading = false
    },
    hasFoto(personal) {
      const urlSinFoto =
        'https://edofza.eoninnovaction.com/CICG_SEG/ESTADO_FUERZA/Files/Fotografia/frente_AARD930724H214693851.jpg'
      return (
        personal.foto &&
        typeof personal.foto === 'string' &&
        personal.foto.trim() !== '' &&
        personal.foto !== urlSinFoto
      )
    },
    getFullName(personal) {
      return `${personal.apaterno} ${personal.amaterno} ${personal.nombre} ${personal.segundoNombre || ''}`.trim()
    },
    parseFechaDirecta(fecha) {
      if (!fecha) return ''
      const formato = /^\d{2}\/\d{2}\/\d{4}$/.test(fecha) ? 'DD/MM/YYYY' : 'YYYY-MM-DD'
      const m = moment(fecha, formato, true)
      return m.isValid() ? m.format('YYYY-MM-DD') : ''
    },
    formatFechaDirecta(fecha) {
      const parsed = this.parseFechaDirecta(fecha)
      return parsed ? moment(parsed, 'YYYY-MM-DD').format('DD/MM/YYYY') : 'Sin fecha'
    },
    getMesesDesdeVigenciaDirecta(fecha) {
      const parsed = this.parseFechaDirecta(fecha)
      if (!parsed) return null
      const meses = moment(parsed, 'YYYY-MM-DD').diff(moment(), 'months', true)
      return meses >= 0 ? meses : 0
    },
    getMesesDesdeVigencia(fechaVigencia) {
      const fechaAjustada = this.getFechaVigenciaAjustada(fechaVigencia)
      if (!fechaAjustada) return null
      const fechaMoment = moment(fechaAjustada, 'YYYY-MM-DD', true)
      if (!fechaMoment.isValid()) return null
      const meses = fechaMoment.diff(moment(), 'months', true)
      return meses >= 0 ? meses : 0
    },
    formatDateAjustada(date) {
      const fechaAjustada = this.getFechaVigenciaAjustada(date)
      if (!fechaAjustada) return 'Sin fecha'
      return moment(fechaAjustada, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    getFechaVigenciaAjustada(fecha) {
      if (!fecha) return null
      let formato = 'YYYY-MM-DD'
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
        formato = 'DD/MM/YYYY'
      }
      const fechaMoment = moment(fecha, formato, true)
      if (!fechaMoment.isValid()) return null
      return fechaMoment.add(3, 'years').format('YYYY-MM-DD')
    },
  },
}
</script>

<style scoped>
/* Títulos y textos - Negro sobre verde para máximo contraste */
.text-h6.font-weight-bold {
  color: #1a2e24 !important;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.2);
}

.primary--text {
  color: rgba(26, 46, 36, 0.9) !important;
}

.text-subtitle-1.primary--text {
  color: rgba(26, 46, 36, 0.8) !important;
}

.text-caption.primary--text {
  color: rgba(26, 46, 36, 0.75) !important;
  font-weight: 500 !important;
}

.secondary--text {
  color: #26de81 !important;
}

/* Avatares */
::v-deep .v-avatar {
  border: 2px solid rgba(26, 46, 36, 0.4);
  transition: all 0.3s ease;
  background: rgba(26, 46, 36, 0.8) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

::v-deep .v-card:hover .v-avatar {
  transform: rotate(5deg) scale(1.1);
  border-color: #1a2e24;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
}

::v-deep .v-avatar .v-icon {
  color: #26de81 !important;
  filter: drop-shadow(0 4px 12px rgba(38, 222, 129, 0.6));
}

/* Imágenes */
::v-deep .v-image {
  border-radius: 8px;
  border: 2px solid rgba(26, 46, 36, 0.4);
  transition: all 0.3s ease;
}

::v-deep .v-card:hover .v-image {
  border-color: #1a2e24;
  transform: scale(1.05);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

/* Botones - Oscuros para contrastar con verde */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

/* Botones homologados del módulo */
::v-deep .ui-module-btn-solid {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  color: #062118 !important;
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.28) !important;
}

::v-deep .ui-module-btn-outline {
  background: rgba(0, 210, 160, 0.08) !important;
  border: 1px solid rgba(0, 210, 160, 0.35) !important;
  color: #26de81 !important;
}

::v-deep .v-btn.primary {
  background: linear-gradient(135deg, #1a2e24 0%, #0f1f18 100%) !important;
  color: #26de81 !important;
  border: 2px solid rgba(38, 222, 129, 0.4) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3) !important;
}

::v-deep .v-btn.primary:hover {
  background: linear-gradient(135deg, #0f1f18 0%, #050a08 100%) !important;
  border-color: #26de81 !important;
  color: #ffffff !important;
}

::v-deep .v-btn.secondary--text {
  color: #00d2a0 !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
  color: #26de81 !important;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
  color: #ffffff !important;
}

/* Input fields */
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 210, 160, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.68) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #26de81 !important;
}

::v-deep .ui-form-field .v-text-field__details,
::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 46, 36, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* Semáforo */
::v-deep .v-chip {
  border-radius: 8px;
  transition: all 0.3s ease;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 210, 160, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 210, 160, 0.6);
}

.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}
</style>
